import { createBrowserHistory } from 'history';
import url from 'url';

let pHistory = null;
const getHistory = () => {
  if (!pHistory) {
    pHistory = createBrowserHistory();
  }
  return pHistory;
};

function updateUrl(location) {
  const history = getHistory();
  history.replace(url.format(location));
}

export default (store) => (next) => (action) => {
  const { location: preLocation } = store.getState();
  const result = next(action);
  const { location: postLocation } = store.getState();

  if (preLocation !== postLocation) {
    updateUrl({ query: postLocation.query, pathname: postLocation.pathname });
  }

  return result;
};
